<template>
  <div
    class="modal modal-widget modal-phone fade"
    id="phoneModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="phoneModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="phoneModalLabel">{{ phone }}</h4>
            <a
              href="#"
              class="icon icon-cross"
              data-dismiss="modal"
              aria-label="Close"
              >{{$t('close')}}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'PhoneModal',
  inheritAttrs: false,
  props:{
    phone: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapFields(['cart']),
  },
  methods: {
   
    closeModal() {
      setTimeout(() => {
        $('#phoneModal').modal('hide')
      }, 500)
    },
  },
}
</script>

<style scoped></style>
